module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.00ce23ca.svg";